export const UPDATE_WARNINGS = {
    CONTRACT: {
        CONTRACT_STATUS: 'Updating the contract status can trigger emails to the customer.'
    },
    RENEWAL: {
        RENEWAL_STATUS: 'Updating the renewal status can trigger emails to the customer.'
    }
}
